module.exports = __webpack_public_path__ + "static/media/mock-up1.9dbe4cf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/mock-up1.png
// module id = 505
// module chunks = 0